import { createSlice } from '@reduxjs/toolkit';
const transaction: any = {};
const filters: any = {};

const transactionManagementSlice = createSlice({
	name: 'transactionManagement',
	initialState: {
		isLoading: false,
		transactions: [],
		transaction,
		filters,
	},
	reducers: {
		setTransactionIsLoading: (state) => {
			state.isLoading = true;
		},
		resetTransactionIsLoading: (state) => {
			state.isLoading = false;
		},
		setTransactions: (state, action) => {
			state.transactions = action.payload;
		},
		resetTransactions: (state) => {
			state.transactions = [];
		},
		setTransaction: (state, action) => {
			state.transaction = action.payload;
		},

		resetTransaction: (state) => {
			state.transaction = {};
		},

		setTransactionFilters: (state, action) => {
			state.filters = action.payload;
		},

		resetTransactionFilters: (state) => {
			state.filters = {};
		},
	},
});
export const {
	setTransaction,
	resetTransaction,
	setTransactionIsLoading,
	resetTransactionIsLoading,
	setTransactions,
	resetTransactions,
	setTransactionFilters,
	resetTransactionFilters,
} = transactionManagementSlice.actions;
export default transactionManagementSlice.reducer;
